<template>
    <div class="leaderboard">
        <LeaderboardBanner
            :top3="leaderboardTop3"
            :active-tab="leaderboardActiveTab"
            @tab-change="leaderboardActiveTab = $event"
        />

        <div class="leaderboard-timer">
            <div class="timer-boxes">
                <div class="timer-box">
                    <span class="timer-value">{{ leaderboardTimerParts[0] }}</span>
                    <span class="timer-unit">Days</span>
                </div>
                <div class="timer-box">
                    <span class="timer-value">{{ leaderboardTimerParts[1] }}</span>
                    <span class="timer-unit">Hours</span>
                </div>
                <div class="timer-box">
                    <span class="timer-value">{{ leaderboardTimerParts[2] }}</span>
                    <span class="timer-unit">Min</span>
                </div>
                <div class="timer-box">
                    <span class="timer-value">{{ leaderboardTimerParts[3] }}</span>
                    <span class="timer-unit">Sec</span>
                </div>
            </div>
        </div>
        <div class="leaderboard-ranks">
            <div class="ranks-header">
                <div class="rank-pos">#</div>
                <div class="rank-user">USER</div>
                <div class="rank-prize">PRIZE</div>
                <div class="rank-wagered">WAGERED</div>
            </div>
            <div class="ranks-content">
              <transition name="fade" mode="out-in">
                    <div v-if="leaderboardData.loading === true" class="content-loading" key="loading">
                        <LoadingAnimation />
                    </div>
                    <div v-else-if="leaderboardData.data !== null" class="content-list" key="data">

                        <LeaderboardUserElement v-for="(winner, index) of leaderboardData.data.winners" v-bind:key="index" v-bind:position="index + 1" v-bind:winner="winner" />

                    </div>
                    <div v-else class="content-empty" key="empty">No leaderboard found.</div>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import LoadingAnimation from '@/components/LoadingAnimation';
    import LeaderboardBanner from '@/components/leaderboard/LeaderboardBanner';
    import LeaderboardUserElement from '@/components/leaderboard/LeaderboardUserElement';
    import Payment from '@/components/Payment';

    export default {
        name: 'Leaderboard',
        metaInfo: {
            title: 'Leaderboard - NOVA-CASINO'
        },
        components: {
            LoadingAnimation,
            LeaderboardBanner,
            LeaderboardUserElement,
            Payment
        },
        data() {
            return {
                leaderboardTimerInterval: null,
                leaderboardTimer: '00:00:00:00',
                leaderboardActiveTab: 'daily'
            }
        },
        methods: {
            ...mapActions([
                'leaderboardGetDataSocket'
            ]),
            leaderboardStartTimer() {
               const endingTime = new Date(this.leaderboardData.data.updatedAt).getTime() + (1000 * 60 * 60 * 24 * Number(this.leaderboardData.data.duration));
               let timeLeft = Math.floor((endingTime - (new Date().getTime() + this.generalTimeDiff)) / 1000);
               timeLeft = timeLeft <= 0 ? 0 : timeLeft;

               let timeDays = Math.floor(timeLeft / (60 * 60 * 24));
               timeDays = timeDays < 10 ? '0' + timeDays : timeDays;
               let timeHours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
               timeHours = timeHours < 10 ? '0' + timeHours : timeHours;
               let timeMinutes = Math.floor((timeLeft % (60 * 60)) / 60);
               timeMinutes = timeMinutes < 10 ? '0' + timeMinutes : timeMinutes;
               let timeSeconds = Math.floor(timeLeft % 60);
               timeSeconds = timeSeconds < 10 ? '0' + timeSeconds : timeSeconds;

               this.leaderboardTimer = timeDays.toString() + ':' + timeHours.toString() + ':' + timeMinutes.toString() + ':' + timeSeconds.toString();
           }
        },
        computed: {
            ...mapGetters([
                'generalTimeDiff', 
                'leaderboardData'
            ]),
            leaderboardTop3() {
                const data = this.leaderboardData.data;
                if (!data || !data.winners || !Array.isArray(data.winners)) return [null, null, null];
                const w = data.winners;
                return [w[0] || null, w[1] || null, w[2] || null];
            },
            leaderboardTimerParts() {
                const pad = (s) => { const v = String(s || '0'); return v.length >= 2 ? v : '0' + v; };
                const parts = this.leaderboardTimer.split(':');
                return [
                    pad(parts[0]),
                    pad(parts[1]),
                    pad(parts[2]),
                    pad(parts[3])
                ];
            }
        },
        watch: {
            'leaderboardData.data': {
                handler() {
                    if(this.leaderboardData.data !== null) { 
                        clearInterval(this.leaderboardTimerInterval);
                        this.leaderboardTimerInterval = setInterval(() => { this.leaderboardStartTimer(); }, 1000);
                    }
                },
                deep: true
            }
        },  
        created() {
            if(this.leaderboardData.loading === false) {
                const data = {};
                this.leaderboardGetDataSocket(data);
            }
        }
    }
</script>

<style scoped>
    .leaderboard {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 65px;
        background: var(--bg-purple-dark);
        background-size: cover;
        background-attachment: fixed;
        min-height: calc(100vh - 80px);
    }

    .leaderboard .leaderboard-timer {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }

    .leaderboard .timer-boxes {
        display: flex;
        gap: 12px;
    }

    .leaderboard .timer-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 72px;
        padding: 14px 16px;
        background: rgba(75, 55, 110, 0.6);
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 12px;
    }

    .leaderboard .timer-value {
        font-size: 28px;
        font-weight: 900;
        color: #fff;
        line-height: 1.2;
        font-variant-numeric: tabular-nums;
    }

    .leaderboard .timer-unit {
        font-size: 12px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.65);
        margin-top: 4px;
    }

    .leaderboard .leaderboard-ranks {
        width: 100%;
        max-width: 955px;
        margin-top: 44px;
        background: var(--bg-secondary);
        border-radius: var(--radius-lg);
        overflow: hidden;
        box-shadow: var(--shadow-sm);
    }

    .leaderboard .ranks-header {
        width: 100%;
        display: flex;
        align-items: center;
        padding: var(--spacing-lg) 25px var(--spacing-lg) 35px;
        background: var(--bg-tertiary);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .leaderboard .rank-pos {
        width: 5%;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .leaderboard .rank-user {
        width: 59%;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .leaderboard .rank-prize,
    .leaderboard .rank-wagered {
        width: 18%;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .leaderboard .ranks-content {
        width: 100%;
        padding: var(--spacing-md);
    }

    .leaderboard .content-loading {
        width: 100%;
        height: 330px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .leaderboard .content-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .leaderboard .content-loading.fade-leave-to {
        opacity: 0;
    }

    .leaderboard .content-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--spacing-sm);
    }

    .leaderboard .content-empty {
        width: 100%;
        height: 192px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 600;
        color: var(--text-muted);
    }

    .leaderboard .content-list.fade-enter-active,
    .leaderboard .content-empty.fade-enter-active {
        transition: opacity 0.5s;
    }

    .leaderboard .content-list.fade-enter-from,
    .leaderboard .content-empty.fade-enter-from {
        opacity: 0;
    }

    .leaderboard .leaderboard-payment-section {
        width: 100%;
        margin-top: 40px;
    }

    @media only screen and (max-width: 975px) {

        .leaderboard .leaderboard-ranks {
            width: 100%;
        }

    }

    @media only screen and (max-width: 700px) {

        .leaderboard .leaderboard-ranks {
            margin-top: 55px;
        }

        .leaderboard .ranks-header {
            display: none;
        }

    }
</style>
